import { render, staticRenderFns } from "./EstimateCopFeeModal.vue?vue&type=template&id=52b8b28c&scoped=true"
import script from "./EstimateCopFeeModal.vue?vue&type=script&lang=js"
export * from "./EstimateCopFeeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b8b28c",
  null
  
)

export default component.exports